import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { GetdecodedURL } from "../../../../../../api/PE_API";

// Update log
// FB  6192   02/06/2023  DK  Redirect the email short links to concern pages

export async function getdecodedURL(urlcode: string): Promise<string> {
    const decodedURL = await GetdecodedURL(urlcode);
    return decodedURL;
}


export default function Redirector(props: any) {
    var url_code = "";
    var { urlcode } = useParams();
    if (urlcode != undefined) {
        url_code = urlcode;
    }

    useEffect(() => {
        onload();
    });

    const onload = async () => {
        const redirectURL = await getdecodedURL(url_code);


        if (!(redirectURL === "" || redirectURL === undefined)) {
            window.location.href = redirectURL;
        }
    }
    return (<div></div>)
}